<script lang="ts" setup>
import BrandIcon from '@components/ui/icons/BrandIcon.vue'
import { useShutdownApp } from '@composables/useShutDownApp'
import { useAppStore } from '@stores/app.store'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useLocale } from '@composables/useLocale'

const props = defineProps<{
  title?: string
}>()

const route = useRoute()
const store = useAppStore()
const { t } = useLocale()
const { handleHeaderClick } = useShutdownApp()

const titleStr = computed(() => {
  if (props.title) return props.title
  if (route.name === 'loyalty') return t('mimcdonalds')
  return store.viewCategory?.title || undefined
})
</script>

<template>
  <header data-test="header" class="flex h-[calc(192*var(--vh))] w-full flex-col justify-end">
    <div
      class="mb-vh-24 mr-vw-24 gap-vw-96 mt-auto ml-[calc(80*var(--vw))] flex flex-row items-center"
    >
      <BrandIcon @click="handleHeaderClick" />
      <h1 v-if="titleStr" class="text-h2 self-center font-bold">{{ titleStr }}</h1>
    </div>
  </header>
</template>
